import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Box from "@material-ui/core/Box";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CardGiftcard from "@material-ui/icons/CardGiftcard";
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme) => ({
    containerCol: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    containerRow: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    btn_auth: {
        background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        borderRadius: 5,
        border: 0,
        color: 'white',
        width: '290px',
        height: '50px',
        fontSize: '11pt',
        boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
    },
    formControl: {
        margin: theme.spacing(1),
        width: 200,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const GoSlon = ({ open, onClose }) => {

    const classes = useStyles();

    const onGoSave = () => {

        onClose();
        window.location.href = "tg://resolve?domain=dobromemi/218";

    };

    return (
        <Dialog onClose={onClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">
                <Box className={classes.containerCol} style={{ marginTop: '0.8rem' }}>
                    <Typography variant="h6" align={'center'}> Что сказал СЛОН, случайно наступив на Колобка? </Typography>
                    <Button onClick={() => { onGoSave() }} className={classes.btn_auth} size="large" variant="contained" color="primary" style={{ marginTop: '0.9rem' }}>
                        ЧТО?
                    </Button>
                    <Button onClick={() => { onClose() }} style={{ marginTop: '0.9rem' }}>
                        закрыть
                    </Button>
                </Box>
            </DialogTitle>
        </Dialog>
    );
}

GoSlon.propTypes = {
    open: PropTypes.bool.isRequired,
};

export default GoSlon;
